import pako from 'pako';

export function startDownload(filename, contentType, buffer) {
  const url = `data:${contentType};base64,${buffer.toString('base64')}`;

  const elLink = document.createElement('a');
  elLink.href = url;
  elLink.download = filename;
  document.body.appendChild(elLink);
  elLink.click();
  elLink.remove();
}

export async function sleep(millis) {
  await new Promise(resolve => setTimeout(resolve, millis));
}

export async function readFile(fileInput) {
  const arrayBuffer = await new Promise(resolve => {
    const fr = new FileReader();

    fr.onload = () => {
      resolve(fr.result);
    };

    fr.readAsArrayBuffer(fileInput.files [0]);
  });

  return Buffer.from(arrayBuffer);
}

export function compressSync(uncompressedBuffer) {
  const uncompressedArray = new Uint8Array(uncompressedBuffer.buffer, uncompressedBuffer.byteOffset, uncompressedBuffer.length);
  const compressedArray = pako.deflate(uncompressedArray);
  const compressedBuffer = Buffer.from(compressedArray);
  return compressedBuffer;
}

export function decompressSync(compressedBuffer) {
  const compressedArray = new Uint8Array(compressedBuffer.buffer, compressedBuffer.byteOffset, compressedBuffer.length);
  const uncompressedArray = pako.inflate(compressedArray);
  const uncompressedBuffer = Buffer.from(uncompressedArray);
  return uncompressedBuffer;
}

function padNumberStr(num, digit) {
  return num.toString().padStart(
    digit, '0',
  );
}

export function formatDate(date, withMs) {
  let retString = '';
  if (date) {
    let tmpDate = date;
    if ((typeof tmpDate === 'string')
        || (typeof tmpDate === 'number')) {
      tmpDate = new Date(tmpDate);
    }
    retString = `${tmpDate.getFullYear()}.${
      padNumberStr(tmpDate.getMonth() + 1, 2)
    }.${
      padNumberStr(tmpDate.getDate(), 2)
    } ${
      padNumberStr(tmpDate.getHours(), 2)
    }:${
      padNumberStr(tmpDate.getMinutes(), 2)
    }:${
      padNumberStr(tmpDate.getSeconds(), 2)
    }${withMs ? `.${
        padNumberStr(tmpDate.getMilliseconds(), 3)
      }` : ''
    }`;
  }
  return retString;
}

export function formatTime(time, withMs) {
  const hh = padNumberStr(Math.floor((time / 3.6e6) % 24), 2);
  const mm = padNumberStr(Math.floor((time % 3.6e6) / 6e4), 2);
  const ss = padNumberStr(Math.floor((time % 6e4) / 1000), 2);
  const ms = (withMs ? (`.${padNumberStr(Math.floor(time % 1000), 3)}`) : '');

  return `${hh}:${mm}:${ss}${ms}`;
}